<p1-lib-ui-elements-image-tile *ngIf="linkTile"
                               [name]="linkTile.name"
                               [link]="linkTile.link"
                               [gtmEventCategory]="'Categorytree'"
                               [gtmEventAction]="'Click Link - Name ' + (linkTile.name | stripNl)"
                               [gtmEventLabel]="'CategorytreeLinkTile'"
                               [openInNewTab]="linkTile.openInNewTab"
                               [ad]="linkTile.ad"
                               [imageUuid]="linkTile.imageUuid">
</p1-lib-ui-elements-image-tile>
